import PropTypes from 'prop-types';

const vmTypePropType = PropTypes.oneOfType([PropTypes.string,
  PropTypes.shape({ // PropType definition for arrays vmPropType
    type: PropTypes.array,
    arrayItemVmType: PropTypes.string
  })]);

export default vmTypePropType;
